import styled from "styled-components";
import { Dropdown } from "antd";

export const StyledDropdown = styled(Dropdown)`
  .ant-dropdown-menu {
    background: transparent;
    border-radius: 4px;
    padding: unset !important;
  }
  .ant-dropdown-menu-item {
    padding: unset !important;
  }
`;
